export default function Hero() {
  const handleScrollTo = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-screen flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20abstract%20composition%20with%20warm%20orange%20and%20deep%20charcoal%20gradients%2C%20subtle%20film%20grain%20texture%2C%20soft%20bokeh%20light%20particles%20floating%2C%20dark%20atmospheric%20background%2C%20luxurious%20movie%20theater%20ambiance%2C%20no%20text%2C%20elegant%20minimal%20abstract%20art%2C%20rich%20contrast%2C%20editorial%20quality&width=1920&height=1080&seq=juzi-hero-bg-01&orientation=landscape"
          alt="桔子影院主题背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/85 via-background-50/70 to-background-50/95"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-background-50/70 via-background-50/30 to-transparent"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-24 md:py-32">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-7xl mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/15 border border-primary-500/25 mb-6">
              <i className="ri-fire-line text-primary-400 text-sm"></i>
              <span className="text-primary-300 text-xs font-medium whitespace-nowrap">
                每日更新 · 热播推荐
              </span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-foreground-50 leading-tight tracking-tight">
              桔子影院
              <span className="block text-primary-400 mt-1">高清免费在线观看平台</span>
            </h1>

            <p className="text-base md:text-lg text-foreground-100 font-medium mt-4 leading-relaxed">
              畅享影视 · 即点即播 · 不缓冲
            </p>

            <p className="text-sm md:text-base text-foreground-400 mt-6 leading-relaxed max-w-xl mx-auto lg:mx-0">
              桔子影院汇聚海量高清影视资源，涵盖热播电视剧、院线大片、经典老片、热门综艺与动漫番剧。
              所有内容免费在线观看，采用智能加速技术确保流畅不缓冲，无论何时何地，打开即享沉浸式观影体验。
              每日同步更新最新剧集与电影，让你不错过任何精彩瞬间。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mt-8">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-accent-400"></div>
                <span className="text-foreground-300 text-sm">日更 50+ 内容</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-accent-400"></div>
                <span className="text-foreground-300 text-sm">全高清画质</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-accent-400"></div>
                <span className="text-foreground-300 text-sm">即点即播无等待</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
              <a
                href="#cards"
                onClick={(e) => handleScrollTo(e, '#cards')}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-xl bg-primary-500 text-background-50 font-bold text-sm whitespace-nowrap cursor-pointer hover:bg-primary-400 transition-colors duration-200"
              >
                <i className="ri-play-circle-line text-lg"></i>
                立即观影
              </a>
              <a
                href="#ranking"
                onClick={(e) => handleScrollTo(e, '#ranking')}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-xl bg-background-200/60 text-foreground-100 font-medium text-sm whitespace-nowrap cursor-pointer border border-background-300/40 hover:bg-background-300/50 transition-colors duration-200"
              >
                <i className="ri-medal-line text-lg"></i>
                查看热播榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-primary-500/10 rounded-2xl blur-2xl"></div>
              <div className="relative rounded-2xl overflow-hidden border border-background-300/30">
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20composition%20featuring%20dramatic%20lighting%2C%20warm%20golden%20and%20amber%20tones%2C%20abstract%20movie%20elements%20with%20lens%20flare%2C%20dark%20theater%20curtain%20texture%2C%20elegant%20cinematic%20aesthetic%2C%20no%20text%2C%20artistic%20photography%20style%2C%20rich%20shadows%20and%20highlights&width=800&height=1000&seq=juzi-hero-visual-02&orientation=portrait"
                  alt="桔子影院主视觉 - 沉浸式观影体验"
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}